<template>
  <div>

    <h4>Period</h4>
    <form
      @submit.prevent="loadActions"
      class="mb-4"
    >
      <table class="period-table">
        <tr>
          <td>Begin</td>
          <td>
            <date-input v-model="beginDateStr"/>
          </td>
          <td>
            <time-input v-model="beginTimeStr"/>
          </td>
        </tr>
        <tr>
          <td>End</td>
          <td>
            <date-input v-model="endDateStr"/>
          </td>
          <td>
            <time-input v-model="endTimeStr"/>
          </td>
        </tr>
      </table>
      <b-button type="submit" variant="primary">Reload</b-button>
    </form>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="actions !== null && actions.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Time</th>
          <th scope="col">IP</th>
          <th scope="col">Type</th>
          <th scope="col">Player</th>
          <th scope="col">Info</th>
        </tr>
      </thead>
      <tr
        v-for="action in actions"
        :key="action.id"
      >
        <td>{{action.id}}</td>
        <td>{{action.ctime | getMomentStr}}</td>
        <td>{{action.userIP | getOptionalStringDefaultStr('unknown')}}</td>
        <td>{{action.type | getEnumInsiderUserActionTypeName}}</td>
        <td>
          <player-link
            v-if="hasPlayer(action)"
            :playerId="action.playerId"
          />
        </td>
        <td>
          <user-action-info
            :action="action"
          />
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />

 </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import UserActionInfo from './UserActionInfo.vue';
import PlayerLink from './PlayerLink.vue';
import DateInput from './DateInput.vue';
import TimeInput from './TimeInput.vue';
import { getEnumInsiderUserActionTypeName } from '../autogen/bundle';

import { convertMomentToDataStr              } from '../util';
import { convertMomentToTimeStr              } from '../util';
import { convertMomentToSec                  } from '../util';
import { convertDataStrAndTimeStrToLocalData } from '../util';

export default {
  name: 'UserActions',

  components: {
    LoadingIndicator,
    UserActionInfo,
    PlayerLink,
    DateInput,
    TimeInput,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    const now = new Date();

    const DEFAULT_DURATION_HOURS = 30 * 24; // 30 days
    const begin = new Date(now.getTime());
    begin.setHours(begin.getHours() - DEFAULT_DURATION_HOURS);
    const beginDateStr = convertMomentToDataStr(begin);
    const beginTimeStr = convertMomentToTimeStr(begin);

    const endDateStr = convertMomentToDataStr(now);
    const endTimeStr = convertMomentToTimeStr(now);

    return {
      MONDAY: 1,

      beginDateStr,
      beginTimeStr,
      endDateStr,
      endTimeStr,

      isLoading: false,

      /** @type {?Object[]} */
      actions: null,
    };
  },

  computed: {
    /** @returns {?Date} */
    beginMoment() {
      return convertDataStrAndTimeStrToLocalData(this.beginDateStr, this.beginTimeStr);
    },

    /** @returns {?Date} */
    endMoment() {
      return convertDataStrAndTimeStrToLocalData(this.endDateStr, this.endTimeStr);
    },

    /** @type {?string} */
    message() {
      if(this.actions !== null && this.actions.length === 0) {
        return 'No actions.';
      }
      return null;
    },
  },

  created() {
    this.loadActions();
  },

  methods: {
    loadActions() {
      notifier.deleteSenderNotifications(this);

      const beginM = this.beginMoment;
      const endM = this.endMoment;
      if(beginM === null || endM === null) {
        notifier.showError(
          'Period is incorrect.',
          {sender: this},
        );
        return;
      }

      const beginMSec  = convertMomentToSec(beginM);
      const endMSec    = convertMomentToSec(endM);

      if(endMSec < beginMSec) {
        notifier.showError(
          'Period is incorrect. Begin must be before end.',
          {sender: this},
        );
        return;
      }

      this.actions = null;
      this.isLoading = true;

      const url = `/user/${this.userId}/actions`;
      const params = {
        begin: beginMSec,
        end: endMSec,
      };

      HTTP.get(
        url,
        {
          params: params,
        }
      )
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const actions = data;
        actions.sort((a, b) => b.id - a.id);

        this.actions = actions;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    hasPlayer(action) {
      if(!('playerId' in action)) {
        return false;
      }
      const playerId = action.playerId;
      if(playerId === undefined || playerId === null) {
        return false;
      }
      return playerId;
    },
  },

  filters: {
    getEnumInsiderUserActionTypeName,
  },
};
</script>

<style scoped>
  .period-table > tr > td {
    padding-right: 0.4em;
    padding-bottom: 0.4em;
  }
</style>